module.exports = __webpack_public_path__ + "static/badge-ltd-4b07a8866f8918abc600d21d49b083d4.svg";